import { ICalendarEntry } from './calendarEntry.model';

export interface ICours {
  id?: string;
  date?: string | null;
  volume?: string | null;
  calendarEntry?: ICalendarEntry;
  profId?: string;
  startDate?: string;
  endDate?: string;
}

export const defaultValue: Readonly<ICours> = {
  id: null,
  date: '',
  volume: '',
  profId: '',
  calendarEntry: null,
  startDate: null,
  endDate: null,
};
